import { createSlice } from "@reduxjs/toolkit";

//sliders in design page
//when the user changes activity categories, activity subtypes and themes of each subtype of its activity type will be fetched
//each subtype will have key 'activityTypeId'

//trending themes will be received from backend
//We will also get activityType and subtype of each trending Theme.

const initialState = {
  sliders: {
    trendingThemes: [
      {
        id: 3001,
        img: "./assets/theme.png",
        name: "theme1",
        activityType: 1002,
        activitySubtype: 10001,
      },
      {
        id: 3002,
        img: "./assets/theme.png",
        name: "theme2",
        activityType: 1002,
        activitySubtype: 10002,
      },
      {
        id: 3003,
        img: "./assets/theme.png",
        name: "theme2",
        activityType: 1002,
        activitySubtype: 10002,
      },
    ],
  },
  megaSlider: {
    active: false,
    activityTypeId: null,
    activitySubtypeId: null,
    activityTypeName: null,
    subtypeName: null
  },
  confirmReplaceModal: {
    active: false,
    master: null
  }
};

//updateSubtypes will be dispatched whenever the category is changed or the selected activity types changes.

const sidebarSliders = createSlice({
  name: "sidebarSliders",
  initialState,
  reducers: {
    updateActivityTypes: (state, { payload }) => {
      state.sidebarSliders = payload;
    },
    updateSubtypes: (state, { payload }) => {
      state.sidebarSliders = payload;
    },
    updateThemes: (state, { payload }) => {
      state.sidebarSliders = payload;
    },
    updateMegaSlider: (state, { payload }) => {
      state.megaSlider = {
        active: payload.active,
        activityTypeId: payload.activityTypeId,
        activitySubtypeId: payload.activitySubtypeId,
        activityTypeName: payload.activityTypeName,
        subtypeName: payload.subtypeName,
      };
    },
    closeMegaSlider: (state, { payload }) => {
      state.megaSlider = {
       ...state.megaSlider,
        active: false,
      };
    },
    toggleConfirmReplaceModal: (state, { payload }) => {
      state.confirmReplaceModal.active = payload;
    },
    updateMasterToReplace: (state, { payload }) => {
      state.confirmReplaceModal.master = payload;
    },
  },
});

export const { updateActivityTypes, updateMegaSlider, closeMegaSlider, toggleConfirmReplaceModal, updateMasterToReplace } = sidebarSliders.actions;
export default sidebarSliders.reducer;
